import { FormDataMappingType } from '~/types/affiliatedObjects';

export const formDataMapping: Readonly<FormDataMappingType> = {
  accounts: {
    SHARED_WITH: {
      BUSINESS: [],
      INDIVIDUAL: [],
    },
  },
  employees: {
    COMMISSION_PAY_TO: {
      BUSINESS: [],
      INDIVIDUAL: [],
      PARTNER: [],
    },
  },
  businesses: {
    EARNINGS_PARENT: {
      ACCOUNT: [],
    },
  },
  partners: {
    EARNINGS_PARENT: {
      ACCOUNT: [],
    },
  },
};

export const isArchivableReference = (resource: string, referenceType: string): boolean =>
  !!formDataMapping[resource]?.[referenceType];
